module.exports = __webpack_public_path__ + "img/e50d86440f29ff2a0d7d74f29c8f7bd5.png";